import { parseApiDate } from "./datetimeLocal";

const dateTimeFormatter = new Intl.DateTimeFormat("es-ES", {
  timeZone: "Europe/Madrid",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const dateFormatter = new Intl.DateTimeFormat("es-ES", {
  timeZone: "Europe/Madrid",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

/** Formats an ISO 8601 UTC timestamp in the panel's official Europe/Madrid timezone. */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "-";
  const date = parseApiDate(value);
  if (Number.isNaN(date.getTime())) return "-";
  return dateTimeFormatter.format(date);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  const date = parseApiDate(value);
  if (Number.isNaN(date.getTime())) return "-";
  return dateFormatter.format(date);
}

/** Relative "hace 5 minutos" style label with a graceful fallback to an absolute date. */
export function formatRelative(value: string | null | undefined): string {
  if (!value) return "-";
  const date = parseApiDate(value);
  if (Number.isNaN(date.getTime())) return "-";

  const diffMs = date.getTime() - Date.now();
  const diffSeconds = Math.round(diffMs / 1000);
  const absSeconds = Math.abs(diffSeconds);

  const rtf = new Intl.RelativeTimeFormat("es-ES", { numeric: "auto" });

  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ["year", 60 * 60 * 24 * 365],
    ["month", 60 * 60 * 24 * 30],
    ["week", 60 * 60 * 24 * 7],
    ["day", 60 * 60 * 24],
    ["hour", 60 * 60],
    ["minute", 60],
  ];

  for (const [unit, secondsInUnit] of units) {
    if (absSeconds >= secondsInUnit) {
      const value = Math.round(diffSeconds / secondsInUnit);
      return rtf.format(value, unit);
    }
  }
  return rtf.format(diffSeconds, "second");
}
